import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const brandRouter: Array<RouteRecordRaw> = [
    {
        path: '/brand',
        component: Layout,
        name: '品牌管理',
        redirect: '/brand/index',
        meta: { title: '品牌管理', icon: 'icon-brand', alwaysShow: true },
        children: [
            {
                path: 'index',
                name: '品牌综合配置',
                component: () => import('@/views/brand/Index.vue'),
                meta: { title: '品牌综合配置', keepAlive: true, depth: 30 }
            },
            {
                path: 'show',
                name: '品牌详情-查看',
                component: () => import('@/views/brand/Detail.vue'),
                meta: { title: '品牌详情-查看' }
            },
            {
                path: 'edit',
                name: '品牌详情-编辑',
                component: () => import('@/views/brand/Detail.vue'),
                meta: { title: '品牌详情-编辑' }
            },
            {
                path: 'brandAdvanceChargeList',
                name: '品牌预付款管理',
                component: () => import('@/views/brand/AdvanceChargeList.vue'),
                meta: { title: '品牌预付款管理', keepAlive: true, depth: 30 }
            },
            {
                path: 'brandAdvanceChargeInfo',
                name: '品牌预付款详情',
                component: () => import('@/views/brand/AdvanceChargeInfo.vue'),
                meta: { title: '品牌预付款详情' }
            },
            {
                path: 'brandAdvanceChargeLog',
                name: '品牌预付款消费日志',
                component: () => import('@/views/brand/AdvanceChargeLog.vue'),
                meta: { title: '品牌预付款消费日志' }
            },
            {
                path: 'distribution-rule',
                name: '品牌城市配规',
                component: () => import('@/views/brand/DistributionRule.vue'),
                meta: { title: '城市配规' }
            },
            {
                path: 'distribution-map',
                name: '配规地图',
                component: () => import('@/views/brand/DistributionMap.vue'),
                meta: { title: '配规地图' }
            },
            {
                path: 'attachment-list',
                name: '收费附件',
                component: () => import('@/views/brand/AttachmentList.vue'),
                meta: { title: '收费附件' }
            },
            {
                path: 'freight-log',
                name: '特殊节日运费增加记录',
                component: () => import('@/views/brand/FreightLog.vue'),
                meta: { title: '特殊节日运费增加记录' }
            },
            {
                path: 'open-cities',
                name: '品牌开通城市',
                component: () => import('@/views/brand/OpenCities.vue'),
                meta: { title: '品牌开通城市' }
            },
            {
                path: 'supplier-second-brand-list',
                name: '供应商二级品牌列表',
                component: () => import('@/views/brand/SupplierSecondBrandList.vue'),
                meta: { title: '供应商二级品牌列表' }
            },
            {
                path: 'second-brand-list',
                name: '平台二级品牌列表',
                component: () => import('@/views/brand/SecondBrandList.vue'),
                meta: { title: '二级品牌管理', KeepAlive: true, depth: 30 }
            },
            {
                path: 'second-brand-edit',
                name: '平台二级品牌编辑',
                component: () => import('@/views/brand/SecondBrandEdit.vue'),
                meta: { title: '二级品牌编辑' }
            },
            {
                path: 'supplier-list',
                name: '平台二级品牌关联供应商',
                component: () => import('@/views/brand/SecondBrandSupplierList.vue'),
                meta: { title: '供应商列表' }
            },
            {
                path: 'm-second-brand-list',
                name: '商户二级品牌列表',
                component: () => import('@/views/merchant-admin/SecondBrandList.vue'),
                meta: { title: '二级品牌列表', KeepAlive: true, depth: 30 }
            },
            {
                path: 'm-second-brand-edit',
                name: '商户二级品牌编辑',
                component: () => import('@/views/merchant-admin/SecondBrandEdit.vue'),
                meta: { title: '二级品牌编辑' }
            },
            {
                path: 'coupon-brand',
                name: '商城电子券品牌管理',
                component: () => import('@/views/brand/CouponBrand.vue'),
                meta: { title: '电子券品牌管理' }
            },
            {
                path: 'expand-brand-edit',
                name: '拓展品牌编辑',
                component: () => import('@/views/brand/ExpandBrandEdit.vue'),
                meta: { title: '拓展品牌编辑' }
            },
        ]
    }
]

export default brandRouter